import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProductionOrderService } from '../services/production-order.service';
import { CommonModule } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { OrderStatusEnum } from '../enums/shipment/order-stauts.enum';
import { ProductOrderBipComponent } from './product-order-bip/product-order-bip.component';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';


interface GroupedProduct {
  title: string;
  variation_attributes: Array<{ name: string; value_name: string }>;
  totalQuantity: number;
  manufacturingEndingDate: any;
}

@Component({
  selector: 'app-checklist',
  standalone: true,
  imports: [CommonModule, FormsModule, ProductOrderBipComponent, TranslocoModule],
  templateUrl: './checklist.component.html',
  styleUrls: ['./checklist.component.css']
})
export class ChecklistComponent {
  groupedProducts: GroupedProduct[] = [];
  loading: boolean = false;
  orders: any[] = [];
  selectAll: boolean = false;
  startDate!: string;
  endDate?: string;
  hasItemChecked: boolean = false;
  OrderStatusEnum = OrderStatusEnum;
  activeTab: string = 'inicial';

  constructor(
    private productioOrderService: ProductionOrderService,
    private toastr: ToastrService,
    private transloco: TranslocoService
  ) { }

  
  // Função para definir a aba ativa
  setActiveTab(tabName: string) {
    this.activeTab = tabName;
  }

  getOrdersForProduction(): void {

    this.loading = true;
    this.hasItemChecked = false;
    this.selectAll = false;
    this.productioOrderService.getOrdersForProduction(new Date(this.startDate), this.endDate ? new Date(this.endDate) : undefined)
      .subscribe({
        next: response => {
          this.loading = false;
          this.orders = response.data;
        },
        error: error => {
          console.log(error);
          this.loading = false;
          this.toastr.error(this.transloco.translate('checklist.toast.searchError'));
        }
      })
  }

  createProductionOrder() {
    let ordersIds = this.orders.filter(order => order.checked).map(order => order.orderId);

    if (ordersIds.length > 0) {
      this.productioOrderService.create(ordersIds)
        .subscribe({
          next: response => {
            this.loading = false;
            this.toastr.success(this.transloco.translate('checklist.toast.orderCreated'));

            this.getOrdersForProduction();
          },
          error: error => {
            this.loading = false;
            this.toastr.error(this.transloco.translate('checklist.toast.orderCreateError'));
          }
        })
    } else {
      this.toastr.error(this.transloco.translate('checklist.toast.selectAtLeastOne'));
    }

  }

  getAttributeValue(product: GroupedProduct, attributeName: string): string {
    const attribute = product.variation_attributes.find(attr => attr.name === attributeName);
    return attribute ? attribute.value_name : 'N/A';
  }

  toggleSelection(order: any) {
    if (order.status == OrderStatusEnum.Cancelado)
      return;

    order.checked = !order.checked;
    this.hasItemChecked = this.orders.find(x => x.checked);
  }


  toggleSelectAll() {
    this.orders.forEach(order => {
      if (order.status != OrderStatusEnum.Cancelado)
        order.checked = this.selectAll;
    });

    this.hasItemChecked = this.selectAll;
  }

}
